import { render, staticRenderFns } from "./chart05.vue?vue&type=template&id=36dceb81"
import script from "./chart05.vue?vue&type=script&lang=js"
export * from "./chart05.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports